import srOnly from '@fukku/styles/src/srOnly.module.css'
import { cx } from 'classix'
import styles from './Loader.module.css'

export interface LoaderProps {
	readonly inverse?: boolean
	readonly loading?: boolean
	readonly className?: string
	readonly accessibilityText: {
		loading: string
		loaded: string
	}
}

export function Loader({
	inverse = false,
	loading = false,
	className,
	accessibilityText,
}: LoaderProps) {
	const computedClassName = cx(styles.square, inverse && styles.inverse)
	return (
		<div aria-live='polite' className={className}>
			{loading ? (
				<div className={cx(styles.loader, inverse && styles.inverse)}>
					<p className={srOnly.className}>{accessibilityText.loading}</p>
					<div className={computedClassName} />
					<div className={cx(computedClassName, styles.square2)} />
					<div className={cx(computedClassName, styles.square3)} />
				</div>
			) : (
				<p className={srOnly.className}>{accessibilityText.loaded}</p>
			)}
		</div>
	)
}
